import fetchClips from './fetch-clips';
import fetchRelatedClips from './fetch-related-clips';

export {
  fetchClips,
  fetchRelatedClips
};




/** WEBPACK FOOTER **
 ** ./src/VO2/libs/api/index.js
 **/